import { Champ } from './champ';
import { Onglet } from './onglet';
import { EntiteDonnee } from './entiteDonnee';
import { ChampOnglet } from './champOnglet';
import { Section } from './section';

export interface IZ16ProLayout {
    champs: Array<Champ>;
    onglets: Array<Onglet>;
    champsOnglets: Array<ChampOnglet>;
    entiteDonnees: Array<EntiteDonnee>;
}

export class Z16ProLayout implements IZ16ProLayout {

    champs: Array<Champ>;
    onglets: Array<Onglet>;
    champsOnglets: Array<ChampOnglet>;
    entiteDonnees: Array<EntiteDonnee>;

    isDirty: boolean;

    public constructor(z16ProLayout: IZ16ProLayout) {
        this.champs         = z16ProLayout.champs;
        this.onglets        = z16ProLayout.onglets;
        this.champsOnglets  = z16ProLayout.champsOnglets;
        this.entiteDonnees  = z16ProLayout.entiteDonnees;
    }

    static fromJson(data: {champs, onglets, champsOnglets, entiteDonnees?, sections?}): Z16ProLayout {
        const champs: Array<Champ> = data.champs.map(champ => {
            return Champ.fromJson(champ);
        });

        const onglets: Array<Onglet> = data.onglets.map(onglet => {
            return Onglet.fromJson(onglet);
        });

        const champsOnglets: Array<ChampOnglet> = data.champsOnglets.map(co => {
            const champOnglet = ChampOnglet.fromJson(co);
            champOnglet.champ = champs.find(champ => champ.id === champOnglet.champId);

            return champOnglet;
        });

        const entiteDonnees: Array<EntiteDonnee> = data.entiteDonnees ? data.entiteDonnees.map(entiteDonnee => {
            return EntiteDonnee.fromJson(entiteDonnee);
        }) : [];

        return new Z16ProLayout({
            champs,
            onglets,
            champsOnglets,
            entiteDonnees
        });
    }

    getFilteredChampsOnglets(filter: (champOnglet: ChampOnglet) => boolean): Array<ChampOnglet> {
        return this.champsOnglets.filter(filter);
    }

    getEntiteDonneeByChamp(champId: string): EntiteDonnee {
        return this.entiteDonnees.find(entiteDonnee => entiteDonnee.champId === champId);
    }

    setDonnee(champ: Champ, valeur: string, businessEntiteId: string) {
        this.isDirty = true;
        let entiteDonnee = this.getEntiteDonneeByChamp(champ.id);

        if (entiteDonnee == null) {
            entiteDonnee = new EntiteDonnee({
                champId: champ.id,
                primaryId: businessEntiteId,
                valeur: valeur
            });

            this.entiteDonnees.push(entiteDonnee);
            return;
        }

        entiteDonnee.valeur = valeur;
    }
}
